<template>
    <div class="sustainable-component wage-block-dificulty-level">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-block-dificulty-level</div>-->


        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printBlockGrades">Visa översikt över värderingsfaktorer</a>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-md-6">
                    <v-form v-model="valid" ref="form">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Gradnummer" :rules="[rules.required, rules.positiveInteger]" v-model="gradeNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Från" :rules="[rules.required, rules.positiveInteger]" v-model="from" variant="outlined"></v-text-field>
                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Till" :rules="[rules.required, rules.positiveInteger]" v-model="to" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" :rules="[rules.required, rules.integer]" label="Poäng" v-model="points" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn size="default" v-bind:disabled="disabled" color="primary" class="btn-primary" @click="addDifficultyLevel">
                                        spara
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-form>
                </div>
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Gradnr.</th>
                                <th class="col-3">Från</th>
                                <th class="col-3">Till</th>
                                <th class="col-2">Poäng</th>
                                <th class="col-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in internalModel.BlockGrades" :key="index">
                                <td class="col-2">
                                    <span>{{item.GradeNumber}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{item.From}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{item.To}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{item.Points}}</span>
                                </td>
                                <td class="col-2">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateGrade(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteBlockGrade(item.BlockGradeId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <WageUpdateBlockGrade v-bind:disabled="disabled" ref="updateBlockGrade" @updated="reload"></WageUpdateBlockGrade>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'
    import WageUpdateBlockGrade from "./update/update-block-grade.vue"
    import { ref } from 'vue'
    const form = ref(null);
    const updateBlockGrade = ref(null);
    
    

    export default {
        emits: ['updated'],
        name: 'wage-block-dificulty-level',
        components: {
            WageUpdateBlockGrade,
            CommonSpinner,
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            updateGrade(item) {
                this.loading++;
                this.updateBlockGrade.open(item);
                this.loading--;
            },
            async printBlockGrades() {
                this.newWindow = window.open('/wagesettingsprint/PrintBlockGrades', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async addDifficultyLevel() {
                this.loading++;
                try {
                    var result = await this.form.validate();
                    if (result.valid != true)
                        return;
                    try {
                        await WageService.addBlockGrade(this.gradeNumber, this.from, this.to, this.points);
                        this.displaySnackBar("Sparat");
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.reload();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async deleteBlockGrade(blockGradeId) {
                if (confirm(" Är du säker att du vill radera graden?")) {
                    this.loading++;
                    try {
                        await WageService.deleteBlockGrade(blockGradeId);
                        this.displaySnackBar("Borttaget");
                        this.reload();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async reload() {
                this.loading++;
                try {
                    var blockGrades = await WageService.getBlockGrades();
                    this.internalModel.BlockGrades = blockGrades;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async init() {
                this.loading++;
                try {
                    var blockGrades = await WageService.getBlockGrades();
                    this.internalModel.BlockGrades = blockGrades;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                valid: false,
                rules: ValidationService.rules(),
                from: null,
                to: null,
                gradeNumber: null,
                points:null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            
        },
        mounted() {
            this.internalModel = this.model;
            this.init();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateBlockGrade, form }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
